import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import ComparisonSection from "./components/ComparisonSection";
import CategoryCards from "./components/CategoryCards";
import CTASection from "./components/CTASection";
import ArticleSection from "./components/ArticleSection";
import TestimonialSection from "./components/TestimonialSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <AboutSection />
      <ComparisonSection />
      <CategoryCards />
      <CTASection />
      <ArticleSection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}